import { EnCuzdanim, HediyeKart } from '@enuygun/icons'
import { useTranslation } from 'next-i18next'
import { useRef, useCallback } from 'react'

import { useDeviceType } from 'hooks/useDeviceType'

import { informationCardData } from './data'
import * as S from './InformationCard.styled'
import { useAppState } from 'context/AppContext'
import { getAnalyticsRequestId } from 'utils/analyticsRequestId'
import sendTrackerLog from 'utils/tracker'

const InformationCard = () => {
  const { isMobile, isTablet } = useDeviceType()

  const { t } = useTranslation('common')

  const { domain, market } = useAppState()
  const domainName = domain === 'tr' ? 'enuygun' : 'wingie'
  const isMobileDevice = !!(isMobile || isTablet)

  const informationCardContainerRef = useRef<HTMLDivElement>(null)

  // InformationCard card click tracking
  const handleInformationCardClick = useCallback(
    (heading: string, subheading: string, href: string, order: number) => {
      const environment = isMobileDevice ? 'MOBILE_WEB' : 'DESKTOP_WEB'
      const requestId = getAnalyticsRequestId()

      sendTrackerLog({
        category: domainName === 'enuygun' ? 'enuygun-homepage' : 'wingie-homepage',
        page: domainName === 'enuygun' ? 'enuygun-homepage' : 'wingie-homepage',
        type: 'click',
        message: 'information_card_click',
        environment: environment,
        requestId,
        cardHeading: heading,
        cardSubheading: subheading,
        linkUrl: href,
        cardOrder: order,
        isMobile: !!isMobileDevice,
        market: market,
      })
    },
    [isMobileDevice, market, domainName]
  )

  // InformationCard mobile card click tracking
  const handleMobileCardClick = useCallback(
    (text: string, href: string, order: number) => {
      const environment = isMobileDevice ? 'MOBILE_WEB' : 'DESKTOP_WEB'
      const requestId = getAnalyticsRequestId()

      sendTrackerLog({
        category: domainName === 'enuygun' ? 'enuygun-homepage' : 'wingie-homepage',
        page: domainName === 'enuygun' ? 'enuygun-homepage' : 'wingie-homepage',
        type: 'click',
        message: 'information_card_mobile_card_click',
        environment: environment,
        requestId,
        cardText: text,
        linkUrl: href,
        cardOrder: order,
        isMobile: !!isMobileDevice,
        market: market,
      })
    },
    [isMobileDevice, market, domainName]
  )

  return (
    <>
      {/* <S.InformationHeading>Seyahatlerini Yönet</S.InformationHeading> */}
      <S.InformationHeading data-testid={`${domainName}-homepage-informationCard-heading`}>{t('informtionCard.heading')}</S.InformationHeading>
      <S.InformationCardContainer ref={informationCardContainerRef} isMobile={isMobile} isTablet={isTablet} data-testid={`${domainName}-homepage-informationCard-container`}>
        {informationCardData.map(({ heading, subheading, icon, src }, index) => {
          return (
            <S.InformationCard isMobile={isMobile} isTablet={isTablet} key={heading} data-testid={`${domainName}-homepage-informationCard-item-${index}-card`}>
              <S.InformationCardLink
                href={src}
                title={heading}
                isTablet={isTablet}
                data-testid={`${domainName}-homepage-informationCard-item-${index}-link`}
                onClick={() => handleInformationCardClick(heading, subheading, src, index + 1)}
              >
                <S.Image width={40} height={40} alt={heading} isTablet={isTablet} data-testid={`${domainName}-homepage-informationCard-item-${index}-image`}>
                  {icon}
                </S.Image>
                <div>
                  <S.informationCardHeading data-testid={`${domainName}-homepage-informationCard-item-${index}-heading`}>{heading}</S.informationCardHeading>
                  <S.informationCardSubheading data-testid={`${domainName}-homepage-informationCard-item-${index}-subheading`}>{subheading}</S.informationCardSubheading>
                </div>
              </S.InformationCardLink>
            </S.InformationCard>
          )
        })}
        {!isMobile && !isTablet && (
          <>
            <S.DividerContainer>
              <S.Divider />
            </S.DividerContainer>
            <S.MobileCards>
              <S.InformationCardSmContainer data-testid={`${domainName}-homepage-informationCard-mobileCards-item-1-container`}>
                <a
                  href="https://www.enuygun.com/enuygun-hediye-kart/"
                  data-testid={`${domainName}-homepage-informationCard-mobileCards-item-1-link`}
                  onClick={() => handleMobileCardClick('Hediye Kart satın al', 'https://www.enuygun.com/enuygun-hediye-kart/', 1)}
                >
                  <S.InformationCardSm>
                    <S.ImageSm>
                      <HediyeKart width={20} height={20} />
                    </S.ImageSm>
                    <S.informationCardSubheading data-testid={`${domainName}-homepage-informationCard-mobileCards-item-1-subheading`}>
                      Hediye Kart satın al
                    </S.informationCardSubheading>
                  </S.InformationCardSm>
                </a>
              </S.InformationCardSmContainer>
              <S.InformationCardSmContainer style={{ marginTop: 28 }} data-testid={`${domainName}-homepage-informationCard-mobileCards-item-2-container`}>
                <a
                  href="https://www.enuygun.com/kredi-karti-puanlari/"
                  data-testid={`${domainName}-homepage-informationCard-mobileCards-item-2-link`}
                  onClick={() => handleMobileCardClick("Kart puanlarını ENCoin'e çevir", 'https://www.enuygun.com/kredi-karti-puanlari/', 2)}
                >
                  <S.InformationCardSm>
                    <S.ImageSm>
                      <EnCuzdanim width={20} height={20} />
                    </S.ImageSm>
                    <S.informationCardSubheading
                      data-testid={`${domainName}-homepage-informationCard-mobileCards-item-2-subheading`}
                    >{`Kart puanlarını ENCoin'e çevir`}</S.informationCardSubheading>
                  </S.InformationCardSm>
                </a>
              </S.InformationCardSmContainer>
            </S.MobileCards>
          </>
        )}
      </S.InformationCardContainer>
    </>
  )
}

export default InformationCard
